/**
 * Google Analytics 4 Event Tracking Utilities
 * Send custom events to GA4 for conversion tracking
 */

/**
 * Send a custom event to Google Analytics 4
 * Events will appear in GA4 and can be marked as conversions
 */
export function trackEvent(eventName: string, eventParams?: Record<string, any>) {
  if (typeof window.gtag !== 'undefined') {
    window.gtag('event', eventName, eventParams);
  }
}

/**
 * Track newsletter signup conversion
 */
export function trackNewsletterSignup(email: string, status: 'new' | 'restored' | 'existing' = 'new') {
  trackEvent('newsletter_signup', {
    method: 'modal',
    status: status,
    event_category: 'engagement',
    event_label: 'Newsletter Subscription',
  });
}

/**
 * Track contact form submission conversion
 */
export function trackContactFormSubmit(name: string, email: string) {
  trackEvent('contact_form_submit', {
    method: 'modal',
    event_category: 'engagement',
    event_label: 'Contact Form',
  });
}

/**
 * Track blog post read completion
 */
export function trackBlogPostRead(postTitle: string, readPercentage: number, timeSpent: number) {
  trackEvent('blog_post_read', {
    post_title: postTitle,
    read_percentage: readPercentage,
    time_spent_seconds: timeSpent,
    event_category: 'engagement',
    event_label: 'Blog Read',
  });
}

/**
 * Track scroll depth milestone
 */
export function trackScrollDepth(depth: number, page: string) {
  trackEvent('scroll_depth', {
    depth_percentage: depth,
    page_path: page,
    event_category: 'engagement',
    event_label: `Scroll ${depth}%`,
  });
}

// Extend Window interface for TypeScript
declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}
